export const defaultDeferIntersectionObserverOptions = {
    root: null,
    rootMargin: '200px',
    threshold: 0,
};
export var DeferCondition;
(function (DeferCondition) {
    DeferCondition["NONE"] = "none";
    DeferCondition["IMMEDIATE"] = "immediate";
    DeferCondition["VISIBLE"] = "visible";
    DeferCondition["IDLE"] = "idle";
    DeferCondition["INTERACTION"] = "interaction";
    DeferCondition["MEDIA"] = "media";
    DeferCondition["CONDITIONAL"] = "conditional";
    DeferCondition["COOKIE"] = "cookie";
})(DeferCondition || (DeferCondition = {}));
export var InteractionType;
(function (InteractionType) {
    InteractionType["CLICK"] = "click";
    InteractionType["MOUSE_ENTER"] = "mouseenter";
    InteractionType["FOCUS"] = "focus";
    InteractionType["TOUCH_START"] = "touchstart";
})(InteractionType || (InteractionType = {}));
//# sourceMappingURL=common.js.map